import React from "react";

const Label = ({ discription, title }) => (
    <p className="font-bahij-normal text-gray-800 text-lg text-tow p-1">
        {title} : <span className=" text-gray-600 font-bahij-bold">{discription}</span>
    </p>
);
export default Label;
